// Shu brauzer/qurilma uchun barqaror identifikator — bir marta generatsiya
// qilinib localStorage'da saqlanadi (logout/login'dan keyin ham o'zgarmaydi).
// Login so'roviga qo'shiladi — qurilma nazorati (deviceControlEnabled)
// yoqilgan foydalanuvchilar uchun backend shu ID orqali qurilmani taniydi.
const KEY = 'deviceId';

export function getDeviceId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = (window.crypto?.randomUUID
      ? window.crypto.randomUUID()
      : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem(KEY, id);
  }
  return id;
}
